import { HardHat } from "lucide-react";
import { useRouter } from "@/lib/nav";
import { useTransition } from "react";
import { toast } from "sonner";

import { Button } from "@buildpy/ui/button";
import { settleRedirect } from "@/lib/redirect-error";
import { createProjectFromContract } from "@/api/actions/project";

// 체결 계약에서 현장을 만든다 — 고객 체결 뒤 자동 생성이 실패했을 때의 복구 버튼이기도 하다.
const CreateProjectButton = ({ contractId }: { contractId: string }) => {
  const router = useRouter();
  const [pending, startTransition] = useTransition();

  const create = () =>
    startTransition(async () => {
      try {
        const result = await createProjectFromContract(contractId);
        if (!result.ok) {
          toast.error(result.message);
          return;
        }
        router.push(`/app/projects/${result.project_id}`);
      } catch (error) {
        if (settleRedirect(error)) return;
        toast.error("현장을 만들지 못했습니다");
      }
    });

  return (
    <Button disabled={pending} onClick={create} size="sm" type="button" variant="primary">
      <HardHat />
      현장 만들기
    </Button>
  );
};

export default CreateProjectButton;
